import { SmallLoader } from 'components/shared/Loader';
import React, { useState } from 'react';
import AddScriptModal from './AddScriptModal';
import { FiEdit, FiPlus } from 'react-icons/fi';

export interface ScriptsInterface {
    id: string;
    name: string;
    desc: string;
    scheduleExec: string;
}

const Script = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [editScriptId, setEditScriptId] = useState("");
    const [scripts, setScripts] = useState<ScriptsInterface[]>([{
        id: Math.random().toString(36).substring(2, 9),
        name: "Data Reduction",
        desc: "Reduces data storage on downgrade",
        scheduleExec: "Run Manually",
    },
    {
        id: Math.random().toString(36).substring(2, 9),
        name: "Feature Access",
        desc: "Manages feature access on downgrade",
        scheduleExec: "Run Automatically",
    },
    {
        id: Math.random().toString(36).substring(2, 9),
        name: "Feature 02",
        desc: "Manages feature access on downgrade",
        scheduleExec: "Run Automatically",
    },
    {
        id: Math.random().toString(36).substring(2, 9),
        name: "Feature 03 Data",
        desc: "Manages feature access on downgrade",
        scheduleExec: "Run Automatically",
    }
    ]);

    const [isAddScriptOpen, setIsAddScriptOpen] = useState<boolean>(false);
    const [mode, setMode] = useState("add");

    const [currentPage, setCurrentPage] = useState(1); // starts from 1
    const itemsPerPage = 2; // you can change this number

    const totalPages = Math.ceil(scripts.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentScripts = scripts.slice(startIndex, endIndex);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleAddScript = () => {
        setIsAddScriptOpen(true);
        setMode("add");
    };

    const handleSaveScript = (newScript: ScriptsInterface) => {
        if (mode === "add") {
            setScripts((prev) => [...prev, newScript]);
        } else {
            setScripts((prev) => prev.map((i) => i.id === editScriptId ? newScript : i));
        }
    };

    const handleEditScript = (id: string) => {
        setEditScriptId(id);
        setMode("edit");
        setIsAddScriptOpen(true);
    };

    return (
        <div className="w-full mt-10">
            <div className="flex justify-between items-center mb-5">
            <h1 className="text-lg font-semibold text-white">Script automation</h1>
                <button
                    onClick={handleAddScript}
                      className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                >
                    <FiPlus size={16} />
                    Add Script
                </button>
            </div>

            <div className="bg-[#2A2A2A]  overflow-hidden rounded-lg">
                <div className="w-full overflow-x-auto bg-[#2A2A2A] ">
                    <table className="min-w-full ">
                        <thead className="bg-[#1A1A1A]">
                            <tr >
                                <th className="text-left p-4 font-medium">
                                    Script name
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Description
                                </th>
                                <th className="text-left p-4 font-medium">
                                    Schedule script execution
                                </th>
                                <th className="text-right p-4 font-medium ">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="">
                            {isLoading ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex justify-center">
                                            <SmallLoader />
                                        </div>
                                    </td>
                                </tr>
                            ) : scripts.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center text-gray-400">
                                        No discount codes found
                                    </td>
                                </tr>
                            ) : (
                                currentScripts.map((script) => (
                                    <tr key={script.id} className='border-b border-white/[0.08] hover:bg-[#3a3a3a33]'>
                                        <td className="p-4 text-gray-300">
                                            {script.name}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {script.desc}
                                        </td>
                                        <td className="p-4 text-gray-300">
                                            {script.scheduleExec}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div className="flex justify-end gap-3">
                                                <button
                                                    onClick={() => handleEditScript(script.id)}
                                                    className="text-blue-500 hover:text-blue-400"
                                                >
                                                    <FiEdit size={18} />
                                                </button>
                                                {/* <button
                                            onClick={() => openDeleteModal(code.id)}
                                            className="text-red-500 hover:text-red-400"
                                        >
                                            <FiTrash2 size={18} />
                                        </button> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>


            {/* Pagination */}
            <div className="flex items-center justify-between mt-4 text-sm text-gray-400">
                <div>
                    Showing {startIndex + 1}-{Math.min(endIndex, scripts.length)} from {scripts.length}
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="p-2 hover:text-white disabled:opacity-50"
                    >
                        ←
                    </button>
                    {pages.map(page => (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`w-8 h-8 rounded flex items-center justify-center ${currentPage === page
                                ? 'bg-[#3A3A3A] text-white'
                                : 'hover:text-white'
                                }`}
                        >
                            {page}
                        </button>
                    ))}
                    <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="p-2 hover:text-white disabled:opacity-50"
                    >
                        →
                    </button>
                </div>
            </div>


            {isAddScriptOpen && <AddScriptModal mode={mode} editScriptId={editScriptId} scripts={scripts} isOpen={isAddScriptOpen} onSave={handleSaveScript} onClose={() => setIsAddScriptOpen(false)} />}
        </div>
    );
};

export default Script;
